import { ContextService } from '../../services/context_service';
import { DatenauswertungEnergietraegerGesamt } from './DatenauswertungEnergietraegerGesamt';
// import { DatenauswertungEnergietraegerNeu } from './DatenauswertungEnergietraegerNeu';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { isValid as isValidWaerme } from '../../main/functions/validData';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import '../../css/tabs.css';

interface DatenauswertungWaermeProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    reloadData: () => void;
    routing: any;
    standortTid: number;
    standortName: string;
    jahrLast?: number;
}

interface DatenauswertungWaermeState {
    tabIndex: number;
}

export class DatenauswertungWaerme extends React.Component<DatenauswertungWaermeProps, DatenauswertungWaermeState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: this.contextService.get('tabIdxDatenauswertungWaerme') || 0
        };
        this.renderTabs = this.renderTabs.bind(this);
    }

    @lazyInject(ContextService) private contextService: ContextService;

    componentDidMount(): void {
        this.checkRouting();
    }

    componentDidUpdate(prevProps: any) {
        if (this.props.routing !== prevProps.routing) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        const tabName: string = RoutingIDs.TABS_DATENAUSWERTUNG_WAERME;
        if (routing.path && routing.path[tabName] !== undefined) {
            // if ((routing.path.terminateOn || null) === tabName) {
            //     this.props.onRoutingChange({});
            // }
            // this.setTabIndex(routing.path[tabName], routing);
            if (this.state.tabIndex === routing.path[tabName]) {
                if (routing.path.terminateOn === tabName) {
                    this.props.onRoutingChange({});
                }
            } else {
                this.setTabIndex(routing.path[tabName], routing);
            }
        }
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void) {
        if (this.state.tabIndex !== tabIndex) {
            const routing: any = JSON.parse(JSON.stringify(this.props.routing || {}));
            const tabName: string = RoutingIDs.TABS_DATENAUSWERTUNG_WAERME;
            if (routing.path && routing.path[tabName] === undefined) {
                // init default tabIndex
                routing.path[tabName] = this.state.tabIndex;
                this.props.onRoutingChange(routing);
            }
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set('tabIdxDatenauswertungWaerme', tabIndex);
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }, 0);
        }
    }

    render(): JSX.Element {
        const tabs = this.renderTabs() || null;
        return (
            <div>
                {tabs && tabs}
                {!tabs && <>Es wurden keine Daten zur Auswertung gefunden.</>}
            </div>
        );
    }

    renderTabs(): JSX.Element {
        const data: any = this.props.data || {};
        const energietraegerWaerme: any[] = data[IDs.ENT_ENERGIEDATEN_WAERME_ENERGIETRAEGER] || [];
        const { standortTid } = this.props;
        const tabListTabs: JSX.Element[] = [];
        const tabPanels: JSX.Element[] = [];
        // console.log('W!!!', data[IDs.ENT_ENERGIEDATEN_WAERME], energietraeger);
        const energiedaten: any[] = (data[IDs.ENT_ENERGIEDATEN_WAERME] || [])
            .filter((item: any) => !this.props.standortTid || this.props.standortTid === item.standort_tid_orig)
            .filter((element: any, index: any, array: any) => {
                const standortOK = (standortTid ? (element.standort_tid_orig || null) === standortTid : true);
                // const energietraegerOK = element.energietraeger_tid_orig
                //    && array.map((item: any) => item.energietraeger_tid_orig).indexOf(element.energietraeger_tid_orig) === index;
                const energietraegerOK = element.energietraeger_tid_orig;
                const validOK = true || isValidWaerme(element, IDs.ENT_ENERGIEDATEN_WAERME, data);
                const monatOK = !(element.monat || 0);
                // console.log('???', standortOK, energietraegerOK, validOK, monatOK, element);
                return standortOK && energietraegerOK && monatOK && validOK;
            })
            .map((item: any) => item.energietraeger_tid_orig);
        const nameSeen: any = {};
        const gesamt: string[] = [];
        let tabWasSet = false;
        energietraegerWaerme.forEach((item: any) => energiedaten.indexOf(item.tid) !== -1 ? gesamt.push(item) : null);
        const energietraeger: any[] = [{ name: 'Gesamt', gesamt }, ...energietraegerWaerme];

        energietraeger.forEach((item: any, index: number) => {
            // const disabled: boolean = (energiedaten.indexOf(item.tid || null) === -1);
            const disabled: boolean = item.gesamt
                ? gesamt.length < 2
                : energiedaten.indexOf(item.tid || null) === -1;
            const tabIndex: number = index;
            // console.log('W?', item, disabled, energiedaten);
            if (tabIndex === this.state.tabIndex && disabled) {
                this.setState({ tabIndex: -1 });
            }
            if ((this.state.tabIndex === -1) && !disabled && !tabWasSet) {
                // console.log('TabIndex', this.state.tabIndex, tabIndex, disabled, tabWasSet);
                // console.log('TabIndex SETTING:', tabIndex);
                tabWasSet = true;
                this.setState({ tabIndex });
            }
            const nameShort = (item.name || '').split('[')[0].trim();
            if (nameSeen[nameShort]) {
                // console.log('Double', nameShort);
                return;
            }
            nameSeen[nameShort] = true;
            tabListTabs.push(this.renderTabsTabListTab(item, tabIndex, disabled));
            tabPanels.push(this.renderTabsTabPanel(item, tabIndex));
        });

        if (energiedaten.length === 0) {
            return <div style={{ margin: 20 }}>Für diesen Standort wurden keine (korrekten) Energiedaten eingegeben</div>;
        }
        const extraRouting: any = {};

        if (this.props.routing && this.props.routing.path) {
            if (this.props.routing.path[RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE] >= 0) {
                extraRouting[RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE] = this.props.routing.path[RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE];
            }
            if (this.props.routing.path[RoutingIDs.TABS_STANDORTE_GRUPPE_ITEM] >= 0) {
                extraRouting[RoutingIDs.TABS_STANDORTE_GRUPPE_ITEM] = this.props.routing.path[RoutingIDs.TABS_STANDORTE_GRUPPE_ITEM];
            }
        }
        const tabRoutings: any[] = energietraeger.map((item: any, index: number) => {
            return {
                path: {
                    ...RoutingIDs.ROUTE_DATENAUSWERTUNG_WAERME,
                    ...extraRouting,
                    [RoutingIDs.TABS_DATENAUSWERTUNG_WAERME]: index,
                    terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG_WAERME
                }
            };
        });

        return (tabListTabs.length
            ? <Tabs
                className={'tabs-datenauswertung'}
                selectedIndex={this.state.tabIndex}
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, tabRoutings[tabIndex])}
            >
                <TabList style={{display: 'none'}}>{tabListTabs}</TabList>
                {tabPanels}
            </Tabs>
            : null
        );
    }

    renderTabsTabListTab(data: any, index: number, disabled: boolean): JSX.Element {
        const nameShort = data.name.split('[')[0].trim();
        // console.log('Tab', nameShort, disabled);
        return <Tab key={`tab-${index}`} disabled={disabled}>{i18n(nameShort, 'tab')}</Tab>;
    }

    renderTabsTabPanel(data: any, index: number): JSX.Element {
        const energietraeger: string[] = [...(data.id ? [data.id] : (data.gesamt || []).map((item: any) => item.id))];
        return (
            <TabPanel key={`panel-${index}`}>
                <DatenauswertungEnergietraegerGesamt
                    data={this.props.data}
                    energietraeger={energietraeger}
                    // energietraeger={data.id || null}
                    onRoutingChange={this.props.onRoutingChange}
                    routing={this.props.routing}
                    standortTid={this.props.standortTid}
                    standortName={this.props.standortName}
                    jahrLast={this.props.jahrLast}
                />
            </TabPanel>
        );
    }
}
